var _g, _g2, _g3, _g4, _g5, _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeIcoHeroSectionBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 339,
    viewBox: "0 0 1920 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_932_1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: 122,
    width: 514,
    height: 125,
    rx: 62.5,
    fill: "url(#paint0_radial_932_1283)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_932_1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 122,
    width: 559,
    height: 125,
    rx: 62.5,
    fill: "url(#paint1_radial_932_1283)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_932_1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 941,
    y: 122,
    width: 572,
    height: 125,
    rx: 62.5,
    fill: "url(#paint2_radial_932_1283)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter3_f_932_1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1439,
    y: 122,
    width: 480,
    height: 125,
    rx: 62.5,
    fill: "url(#paint3_radial_932_1283)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter4_f_932_1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.916,
    y: 150,
    width: 1535.2,
    height: 28,
    rx: 14,
    fill: "url(#paint4_linear_932_1283)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7795 122H-21.9881C-25.3001 122 -27.985 124.686 -27.985 128L-31.293 321.5C-31.293 324.813 -28.6081 327.5 -25.2961 327.5H1937.68C1940.99 327.5 1943.68 324.813 1943.68 321.5L1946.99 128C1946.99 124.686 1944.3 122 1940.99 122H1833.67C1832.09 122 1830.58 122.622 1829.46 123.732L1811.38 141.601C1810.24 142.728 1809.59 144.265 1809.59 145.869V156.691C1809.59 160.004 1806.91 162.691 1803.59 162.691H1774.43C1771.11 162.691 1768.43 160.004 1768.43 156.691V149.363C1768.43 146.049 1765.74 143.363 1762.43 143.363H1713.7C1710.39 143.363 1707.7 140.676 1707.7 137.363V128C1707.7 124.686 1705.02 122 1701.7 122H1671.57C1670 122 1668.48 122.622 1667.36 123.732L1649.25 141.631C1648.13 142.74 1646.61 143.363 1645.03 143.363H1606.67C1603.36 143.363 1600.68 146.049 1600.68 149.363V156.691C1600.68 160.004 1597.99 162.691 1594.68 162.691H1536.69C1533.37 162.691 1530.69 160.004 1530.69 156.691V149.363C1530.69 146.049 1528 143.363 1524.7 143.363H1506.33C1503.02 143.363 1500.33 140.676 1500.33 137.363V128C1500.33 124.686 1497.64 122 1494.33 122H1420.97C1419.39 122 1417.88 122.622 1416.75 123.732L1398.68 141.601C1397.54 142.728 1396.89 144.265 1396.89 145.869V156.691C1396.89 160.004 1394.21 162.691 1390.9 162.691H1339.08C1335.78 162.691 1333.09 160.004 1333.09 156.691V149.363C1333.09 146.049 1330.41 143.363 1327.09 143.363H1305.12C1301.81 143.363 1299.12 146.049 1299.12 149.363V156.691C1299.12 160.004 1296.45 162.691 1293.13 162.691H1199.64C1196.32 162.691 1193.64 160.004 1193.64 156.691V149.363C1193.64 146.049 1190.95 143.363 1187.64 143.363H1082.31C1079 143.363 1076.31 146.049 1076.31 149.363V156.691C1076.31 160.004 1073.63 162.691 1070.31 162.691H1041.14C1037.83 162.691 1035.14 160.004 1035.14 156.691V128C1035.14 124.686 1032.46 122 1029.14 122H976.372C974.794 122 973.279 122.622 972.157 123.732L954.048 141.631C952.926 142.74 951.412 143.363 949.834 143.363H927.933C924.621 143.363 921.936 146.049 921.936 149.363V156.691C921.936 160.004 919.252 162.691 915.939 162.691H879.048C875.735 162.691 873.051 160.004 873.051 156.691V149.363C873.051 146.049 870.366 143.363 867.054 143.363H764.295C760.983 143.363 758.298 146.049 758.298 149.363V156.691C758.298 160.004 755.614 162.691 752.302 162.691H662.922C659.611 162.691 656.925 160.004 656.925 156.691V145.869C656.925 144.265 656.284 142.728 655.143 141.601L637.065 123.732C635.942 122.622 634.428 122 632.851 122H471.051C469.473 122 467.959 122.622 466.836 123.732L448.728 141.631C447.605 142.74 446.091 143.363 444.513 143.363H417.466C414.154 143.363 411.469 146.049 411.469 149.363V156.691C411.469 160.004 408.785 162.691 405.472 162.691H360.861C357.55 162.691 354.865 160.004 354.865 156.691V149.363C354.865 146.049 352.18 143.363 348.868 143.363H290.879C287.567 143.363 284.882 146.049 284.882 149.363V156.691C284.882 160.004 282.196 162.691 278.885 162.691H183.846C180.533 162.691 177.849 160.004 177.849 156.691V149.363C177.849 146.049 175.163 143.363 171.852 143.363H92.3172C90.7395 143.363 89.2252 142.74 88.1027 141.631L69.9941 123.732C68.8716 122.622 67.3573 122 65.7795 122Z",
    fill: "#070710",
    stroke: "#944FEB",
    strokeOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 309,
    width: 1920,
    height: 30,
    fill: "#070710"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_932_1283",
    x: -61.5,
    y: 77.5,
    width: 603,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.25,
    result: "effect1_foregroundBlur_932_1283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_932_1283",
    x: 395.5,
    y: 77.5,
    width: 648,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.25,
    result: "effect1_foregroundBlur_932_1283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_932_1283",
    x: 896.5,
    y: 77.5,
    width: 661,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.25,
    result: "effect1_foregroundBlur_932_1283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_932_1283",
    x: 1394.5,
    y: 77.5,
    width: 569,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.25,
    result: "effect1_foregroundBlur_932_1283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_932_1283",
    x: 13.916,
    y: 0,
    width: 1835.2,
    height: 328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_932_1283"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_932_1283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 184.5) scale(363.453 88.3883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_932_1283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(719.5 184.5) scale(395.273 88.3883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_932_1283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1227 184.5) scale(404.465 88.3883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_932_1283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1679 184.5) scale(339.411 88.3883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_932_1283",
    x1: 931.516,
    y1: 150,
    x2: 931.516,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FC6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B30FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeIcoHeroSectionBottom);
export default __webpack_public_path__ + "static/media/shape_ico_hero_section_bottom.644393f86f11eb3efbc402e79253e224.svg";
export { ForwardRef as ReactComponent };